export default __webpack_public_path__ + "static/media/green-arrow.3f6457be.svg";